import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Typography from '@material-ui/core/Typography';
import {
  FormControlLabel,
  Link,
  MenuItem,
  Radio,
  RadioGroup,
  TextField
} from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getAccounts } from '../../actions/Accounts';
import BatchShopButton from '../../components/atoms/BatchShopButton';
import {
  listBatchShop,
  validateBatchShop,
  batchShopImportFile,
  GET_BATCH_SHOP_SUCCESS,
  VALIDATE_BATCH_SHOP_SUCCESS,
  ADD_BATCH_SHOP_IMPORT_FILE_SUCCESS
} from '../../actions/Shop';
import '../../stylesheets/csv.css';
import SearchButton from '../../components/atoms/SearchButton';
import BatchShopTable from '../organisms/BatchShopTable';
import batchShopStatuses from '../../constants/BatchShopStatuses';

const styles = theme => ({
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  pageDiscriptionDiv: {
    paddingLeft: 26,
    paddingTop: 2,
    textAlign: 'left'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 26px 10px 26px',
    maxWidth: 700
  },
  description: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  buttonGroupLeft: {
    textAlign: 'left'
    // float: 'left'
  },
  buttonRight: {
    textAlign: 'right'
  },
  buttonGroupRight: {
    textAlign: 'right'
  },
  textInput100: {
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  flex: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  inputContainer: {
    padding: 30,
    display: 'flex',
    flexDirection: 'column-reverse'
  },
  flexColumnRevert: {
    display: 'flex',
    flexDirection: 'column-reverse'
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  searchFormContainer: {
    backgroundColor: '#fff',
    margin: 15
  },
  horizotalLine: {
    borderBottom: '15px solid #DBDBDB'
  }
});

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getAccounts,
          listBatchShop,
          validateBatchShop,
          batchShopImportFile
        },
        dispatch
      )
    })
  ),
  withState('file', 'setFile', null),
  withState('resultMessage', 'setResultMessage', ''),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('loading', 'updateLoading', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('isAddSuccess', 'updateIsAddSuccess', false),
  withState('shopName', 'setShopName', null),
  withState('gochiUserId', 'setGochiUserId', null),
  withState('batchLogId', 'setBatchLogId', null),
  withState('createdAt', 'setCreatedAt', null),
  withState('status', 'setStatus', ''),
  withState('page', 'setPage', 1),
  withState('openTable', 'updateOpenTable', true),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('openConfirm', 'updateOpenConfirm', false),
  withState('validateData', 'setValidateData', {}),
  withState('sendMail', 'setSendMail', 1),
  withHandlers({
    checkSession: props => data => {
      console.log(data);
      if (
        data.error === true &&
        typeof data.payload !== 'undefined' &&
        data.payload.status === 403
      ) {
        sendLogin(props);
      }
      return data;
    }
  }),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleChangePage: props => (event, page, limit) => {
      const limitNum = limit || props.rowsPerPage;
      console.log('HANDLE CHANGE PAGE');
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const searchKey = {
        shopName: props.shopName,
        batchLogId: props.batchLogId,
        createdAt: props.createdAt,
        status: props.status,
        page,
        limit: limitNum
      };

      props.updateLoading(true);
      // props.updateOpenProgress(true);
      props.actions.listBatchShop(searchKey).then(data => {
        props.checkSession(data);
        if (data.type === GET_BATCH_SHOP_SUCCESS) {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
        } else {
          props.setResultMessage('エラーが発生しました！');
          props.updateLoading(false);
        }
      });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
        this.props.handleChangePage(null, 1, this.props.rowsPerPage);
      });
    }
  })
);

const Main = enhance(
  ({
    actions,
    account,
    classes,
    file,
    setFile,
    resultMessage,
    setResultMessage,
    checkSession,
    openDrawer,
    updateOpenDrawer,
    openProgress,
    openTable,
    updateOpenTable,
    updateOpenProgress,
    loading,
    updateLoading,
    batchLogId,
    setBatchLogId,
    createdAt,
    setCreatedAt,
    status,
    setStatus,
    handleChangePage,
    page,
    rowsPerPage,
    setRowsPerPage,
    openConfirm,
    updateOpenConfirm,
    validateData,
    setValidateData,
    shopName,
    setShopName,
    sendMail,
    setSendMail
  }) => {
    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      setResultMessage
    };

    const searchAction = async () => {
      updateOpenTable(true);
      handleChangePage(null, 1, rowsPerPage);
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
      updateLoading(true);
      handleChangePage(null, page, rowsPerPage);
    };

    const validateAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const formData = new FormData();
      if (file) {
        const fileSize = file.size;

        if (fileSize > 3 * 1024 ** 2) {
          setResultMessage('3MB以下のファイルをアップロードしてください。');
          updateLoading(false);
          return;
        }

        formData.append('file', file, file.name);
        console.log(file);
        const uploadedFile = await actions
          .validateBatchShop(formData)
          .then(data => checkSession(data));

        if (uploadedFile.type === VALIDATE_BATCH_SHOP_SUCCESS) {
          setValidateData(uploadedFile.payload);
          updateOpenConfirm(true);
          updateLoading(false);
          updateOpenProgress(false);
        } else {
          setResultMessage('エラーが発生しました！');
          updateLoading(false);
        }
      } else {
        setResultMessage('ファイルが選択されていません。');
        updateLoading(false);
      }
    };

    const registerAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const formData = new FormData();
      if (file) {
        formData.append('file', file, file.name);
        formData.append('sendMail', sendMail);
        console.log(file);
        const uploadedFile = await actions
          .batchShopImportFile(formData)
          .then(data => checkSession(data));

        if (uploadedFile.type === ADD_BATCH_SHOP_IMPORT_FILE_SUCCESS) {
          if (uploadedFile.payload.code === 200) {
            setResultMessage('データをインポートしました');
          } else {
            setResultMessage(
              'データのインポートに失敗しました。もう一度やり直してください'
            );
          }
          updateLoading(false);
          updateOpenConfirm(false);
        } else {
          if (uploadedFile.payload && uploadedFile.payload.status === 504) {
            setResultMessage(
              'データのインポートを処理中です。\n約10分後に画面の表示を再度ご確認ください。'
            );
          } else {
            setResultMessage(
              'データのインポートに失敗しました。もう一度やり直してください'
            );
          }
          updateLoading(false);
          updateOpenConfirm(false);
        }
      } else {
        setResultMessage('ファイルが選択されていません。');
        updateLoading(false);
      }
    };

    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            店舗一括登録
          </Typography>
        </div>
        <Paper>
          <div className={classes.searchFormContainer}>
            <div className={classes.flex}>
              <div className={classes.searchForm}>
                <TextField
                  label="店舗名"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={shopName}
                  onChange={e => {
                    setShopName(e.target.value);
                  }}
                />
                <TextField
                  label="一括登録ID"
                  type="search"
                  className={classes.textField}
                  margin="normal"
                  value={batchLogId}
                  onChange={e => {
                    setBatchLogId(e.target.value);
                  }}
                />
                <TextField
                  label="インポート日"
                  type="date"
                  className={classes.textField}
                  margin="normal"
                  value={createdAt}
                  onChange={e => {
                    setCreatedAt(e.target.value);
                  }}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <TextField
                  select
                  label="ステータス"
                  className={classes.textField}
                  margin="normal"
                  value={status}
                  onChange={e => {
                    setStatus(e.target.value);
                  }}
                >
                  {batchShopStatuses.map(item => {
                    return (
                      <MenuItem key={item.id} value={item.value}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </TextField>
                <div className={classes.buttonGroupLeft}>
                  <SearchButton onClickAction={searchAction} />
                </div>
              </div>
              <div className={`${classes.flex} ${classes.inputContainer}`}>
                <a
                  href="https://d2mdjfflfn266g.cloudfront.net/public/files/batch_shop_sample_file.xlsx"
                  download="batch_shop_sample_file.xlsx"
                  // eslint-disable-next-line react/jsx-no-target-blank
                  target="_blank"
                >
                  EXCELフォーマットダウンロード
                </a>
                <div>
                  <div>登録完了した店舗にメールを送信しますか？</div>
                  <RadioGroup
                    value={sendMail}
                    onChange={e => {
                      setSendMail(parseInt(e.target.value, 10));
                    }}
                  >
                    <FormControlLabel
                      value={1}
                      control={<Radio color="primary" />}
                      label="送信する"
                    />
                    <FormControlLabel
                      value={0}
                      control={<Radio color="primary" />}
                      label="送信しない(チェーン店等の一括登録時に選択)"
                    />
                  </RadioGroup>
                </div>
                <div className={classes.flexRow}>
                  <input
                    type="file"
                    onChange={e => {
                      setFile(e.target.files[0]);
                    }}
                    onClick={e => {
                      e.target.value = '';
                    }}
                  />
                  <BatchShopButton
                    onClickAction={validateAction}
                    registerAction={registerAction}
                    name="登録"
                    validateData={validateData}
                    openConfirm={openConfirm}
                    updateOpenConfirm={updateOpenConfirm}
                    classes={classes}
                  />
                </div>
              </div>
            </div>
            <div className={classes.description}>
              下記の設定をAI&Tさんへ redmine で依頼してください。
              <br />
              ■会計完了画面でバーコード表示が必要な場合（対応済：吉野家、その他店舗は開発が必要→Developへ依頼）
              <br />
              ①店舗コードをインサート
              <br />
              <br />
              ■モグゴリアプリ（
              <Link
                href="https://gochi.online/mogugori"
                target="_blank"
                rel="noreferrer"
              >
                https://gochi.online/mogugori
              </Link>
              ）
              <br />
              ①店舗をモグゴリアプリに追加（
              <Link
                href="https://redmine.1steam.com:8443/issues/123689"
                target="_blank"
                rel="noreferrer"
              >
                参考Redmineチケット
              </Link>
              ）
              <br />
              ②店舗をモグゴリアプリから外す（
              <Link
                href="https://redmine.1steam.com:8443/issues/113790"
                target="_blank"
                rel="noreferrer"
              >
                参考Redmineチケット
              </Link>
              ）
              <br />
              <br />
              ※店舗一括登録ジョブの仕様
              <br />
              ・1分に1回実行して、毎回10件を処理する
              <br />
              ※1回でアップロードできるファイルの容量は3MB（10000件ぐらい）
            </div>
          </div>
          <div className={classes.horizotalLine} />
          {openTable && (
            <BatchShopTable
              page={page}
              handleChangePage={handleChangePage}
              progress={progress}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              setResultMessage={setResultMessage}
              updateOpenProgress={updateOpenProgress}
              updateLoading={updateLoading}
            />
          )}
        </Paper>

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
